(function(){
  function list(s){return (s||"").toLowerCase().split(",").map(function(x){return x.trim();}).filter(Boolean)}
  function uniq(a){var m={};return a.filter(function(x){if(!x||m[x])return false;m[x]=1;return true})}
  function cfg(){
    var c=document.getElementById("hc-sku-config");if(!c)return null;
    var hAll=list(c.getAttribute("data-hammocks-all")||"");
    var pAll=list(c.getAttribute("data-pads-all")||"");
    var h=list(c.getAttribute("data-hammocks")||"");
    var p=list(c.getAttribute("data-pads")||"");
    var hLW=list(c.getAttribute("data-hammocks-lw")||"");
    var hXL=list(c.getAttribute("data-hammocks-xl")||"");
    var pLW=list(c.getAttribute("data-pads-lw")||"");
    var pXL=list(c.getAttribute("data-pads-xl")||"");
    if(hAll.length===0)hAll=uniq([].concat(h,hLW,hXL));
    if(pAll.length===0)pAll=uniq([].concat(p,pLW,pXL));
    return {hAll:hAll,pAll:pAll,hLW:hLW,hXL:hXL,pLW:pLW,pXL:pXL};
  }
  function tally(items,c){
    var r={h:0,p:0,hlw:0,hxl:0,plw:0,pxl:0};
    for(var i=0;i<items.length;i++){
      var it=items[i],sku=(it.sku||"").toString().trim().toLowerCase(),q=it.quantity||0;
      if(!sku||q<=0)continue;
      if(c.hAll.indexOf(sku)>-1)r.h+=q;
      if(c.pAll.indexOf(sku)>-1)r.p+=q;
      if(c.hLW.indexOf(sku)>-1)r.hlw+=q;
      if(c.hXL.indexOf(sku)>-1)r.hxl+=q;
      if(c.pLW.indexOf(sku)>-1)r.plw+=q;
      if(c.pXL.indexOf(sku)>-1)r.pxl+=q;
    }
    return r;
  }
  function decide(k){
    var gen=(k.h>0&&k.p===0)?1:0;
    var showLW=(k.hlw>0&&k.plw===0)?1:0;
    var showXL=(k.hxl>0&&k.pxl===0)?1:0;
    if(gen===1){showLW=0;showXL=0}
    return {gen:gen,lw:showLW,xl:showXL};
  }
  function show(el,flag){if(!el)return;el.classList[flag?"add":"remove"]("hc-cart-error-shown")}
  function applyInto(root,s){
    if(!root)return;
    show(root.querySelector('.hc-hammocks-pads-error[data-hc-msg="gen"]'),s.gen===1);
    show(root.querySelector('.hc-hammocks-pads-error[data-hc-msg="lw"]'),s.lw===1);
    show(root.querySelector('.hc-hammocks-pads-error[data-hc-msg="xl"]'),s.xl===1);
  }
  var pending=null,lastSig="";
  function signature(k){return [k.h,k.p,k.hlw,k.hxl,k.plw,k.pxl].join("|")}
  function apply(){
    var C=cfg();if(!C)return;
    fetch("/cart.js?ts="+Date.now(),{credentials:"same-origin",cache:"no-store"}).then(function(r){return r.json();}).then(function(cart){
      var k=tally(cart.items||[],C),sig=signature(k);if(sig===lastSig&&document.visibilityState==="visible")return;lastSig=sig;
      var s=decide(k);
      var roots=[];
      var page=document.querySelector('#CartPageForm'); if(page) roots.push(page);
      var drawer=document.querySelector('#CartDrawerForm'); if(drawer) roots.push(drawer);
      document.querySelectorAll('.hc-hammocks-pads-error').forEach(function(x){var f=x.closest('form');if(f&&roots.indexOf(f)===-1)roots.push(f)});
      roots.forEach(function(r){applyInto(r,s)});
    }).catch(function(){});
  }
  function schedule(){if(pending)cancelAnimationFrame(pending);pending=requestAnimationFrame(apply)}
  document.addEventListener("DOMContentLoaded",apply);
  document.addEventListener("cart:updated",schedule);
  document.addEventListener("ajaxCart.afterUpdate",schedule);
  document.addEventListener("cart:update",schedule);
  document.addEventListener("ajaxProduct:added",schedule);
  document.addEventListener("visibilitychange",function(){if(!document.hidden)schedule()});
  window.addEventListener("pageshow",schedule);
  document.body.addEventListener("change",function(e){
    if(e.target&&e.target.matches('input[name="updates[]"],input[type="number"][name="quantity"],.ajaxcart__qty-num'))setTimeout(schedule,0);
  });
  document.body.addEventListener("click",function(e){
    var a=e.target.closest('a[href*="change?line="],a[href*="quantity="],.cart__remove,.ajaxcart__remove,button[name="update"],button[name="minus"],button[name="plus"],.js-drawer-close');
    if(a)setTimeout(schedule,0);
  });
  var obsTargets=[document.querySelector('[data-products]'),document.querySelector('#CartDrawer [data-products]'),document.querySelector('#CartDrawerForm')];
  obsTargets.forEach(function(t){ if(t){ new MutationObserver(function(){schedule()}).observe(t,{childList:true,subtree:true}); }});
})();
